exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-08f8f796] {\n  padding-left: 20%;\n  padding-right: 20%;\n}\n", ""]);

// exports
